<template>
  <basic-container>
    <!-- 页面头部信息 -->
    <div class="page-header" v-if="sessionInfo">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="info-item">
            <label>会话ID：</label>
            <span>{{ sessionInfo.sessionId }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <label>会话标题：</label>
            <span>{{ sessionInfo.sessionTitle || '无标题' }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <label>chatId：</label>
            <span>{{ sessionInfo.chatId }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    
    <!-- 任务列表 -->
    <avue-crud 
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      ref="crud"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange">
      
      <!-- 任务状态显示 -->
      <template slot="taskState" slot-scope="scope">
        <el-tag 
          :type="getStatusColor(scope.row.taskState)"
          size="small">
          {{ getTaskStateText(scope.row.taskState) }}
        </el-tag>
      </template>
      
      <!-- 任务类型显示 -->
      <template slot="taskType" slot-scope="scope">
        <el-tag 
          :type="getTaskTypeColor(scope.row.taskType)"
          size="small">
          {{ getTaskTypeText(scope.row.taskType) }}
        </el-tag>
      </template>
      
        <!-- 执行时长显示 -->
      <template slot="executeMills" slot-scope="scope">
        <span>{{ scope.row.executeMills || '0' }}</span>
      </template>
      <!-- 任务内容显示 -->
      <template slot="content" slot-scope="scope">
        <div class="task-content">
          <el-tooltip 
            :content="scope.row.content"
            placement="top"
            :disabled="!scope.row.content || scope.row.content.length <= 50">
            <span>{{ truncateText(scope.row.content, 50) }}</span>
          </el-tooltip>
        </div>
      </template>
      
      <!-- 结果内容显示 -->
      <template slot="result" slot-scope="scope">
        <div class="task-result">
          <el-tooltip 
            :content="scope.row.result"
            placement="top"
            :disabled="!scope.row.result || scope.row.result.length <= 50">
            <span>{{ truncateText(scope.row.result, 50) }}</span>
          </el-tooltip>
        </div>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import { getAiSessionTaskList } from "@/api/aiSession";

export default {
  name: 'AiSessionTasks',
  
  data() {
    return {
      loading: false,
      data: [],
      sessionInfo: null,
      page: {
        size: 10,
        current: 1,
        total: 0
      },
      option: {
        height: 'auto',
        calcHeight: 30,
        tip: false,
        searchShow: false,
        border: true,
        index: true,
        menu: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        selection: false,
        dialogClickModal: false,
        labelWidth: 120,
        labelPosition: 'right',
        span: 8,
        column: [
          {
            label: "任务ID",
            prop: "taskId",
            minWidth: 120,
            overHidden: true,
            tip: true
          },{
            label: "chatId",
            prop: "chatId",
            minWidth: 120,
            overHidden: true,
            tip: true
          },
          {
            label: "客户端UID",
            prop: "uid",
            width: 120,
            overHidden: true,
            tip: true
          },
          {
            label: "执行UID",
            prop: "executeUid",
            width: 120,
            overHidden: true,
            tip: true
          },
          {
            label: "是否主任务",
            prop: "mainTask",
            width: 100,
            formatter: (row) => {
              return row.mainTask === 1 ? '是' : '否';
            }
          },
          {
            label: "主任务ID",
            prop: "mainTaskId",
            width: 120,
            overHidden: true,
            tip: true
          },
          {
            label: "任务类型",
            prop: "taskType",
            width: 100,
            slot: true
          },
          {
            label: "任务状态",
            prop: "taskState",
            width: 100,
            slot: true
          },
          {
            label: "任务内容",
            prop: "content",
            minWidth: 200,
            slot: true
          },
          {
            label: "执行时长(ms)",
            prop: "executeMills",
            width: 120,
            type: "number",
            slot: true
          },
          {
            label: "执行结果",
            prop: "result",
            minWidth: 200,
            slot: true
          },
          {
            label: "创建时间",
            prop: "createTime",
            width: 160,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          },
          {            
            label: "执行时间",
            prop: "executeTime",
            width: 160,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          },
          {
            label: "完成时间",
            prop: "endTime",
            width: 160,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          }
        ]
      }
    };
  },
  
  mounted() {
    // 初始从路由读取参数
    this.initFromRoute();
  },
  
  watch: {
    // 监听路由参数变更，支持同页内切换不同消息
    '$route.query.chatId'(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.initFromRoute();
      }
    },
    '$route.query.sessionId'(newVal, oldVal) {
      if (this.sessionInfo && newVal !== oldVal) {
        this.sessionInfo.sessionId = newVal;
      }
    },
    '$route.query.sessionTitle'(newVal, oldVal) {
      if (this.sessionInfo && newVal !== oldVal) {
        this.sessionInfo.sessionTitle = newVal;
      }
    }
  },
  
  methods: {
    // 从路由参数初始化并加载
    initFromRoute() {
      const routeSessionId = this.$route.query.sessionId;
      const routeSessionTitle = this.$route.query.sessionTitle;
      const routeChatId = this.$route.query.chatId;
      this.sessionInfo = {
        sessionId: routeSessionId,
        sessionTitle: routeSessionTitle,
        chatId  : routeChatId
      };
      // 缺少消息ID时，不强制回退，保持静默并清空数据，避免关闭页面时报错
      if (!this.sessionInfo.chatId) {
        this.page.current = 1;
        this.page.total = 0;
        this.data = [];
        this.loading = false;
        return;
      }
      // 路由变更时重置分页到第一页并加载
      this.page.current = 1;
      this.loadTaskList();
    },
    
    // 获取任务状态颜色
    getStatusColor(status) {
      const statusMap = {
        0: 'warning',
        1: 'primary',
        2: 'success',
        3: 'danger',
        4: 'info'
      };
      return statusMap[status] || 'info';
    },
    
    // 获取任务状态文本
    getTaskStateText(status) {
      const statusMap = {
        0: '待执行',
        1: '执行中',
        2: '执行成功',
        3: '执行失败',
        4: '已中断'
      };
      return statusMap[status] || status;
    },
    
    // 获取任务类型颜色
    getTaskTypeColor(type) {
      const typeMap = {
        'text': 'primary',
        'image': 'success',
        'audio': 'warning',
        'video': 'danger',
        'file': 'info'
      };
      return typeMap[type] || 'info';
    },
    
    // 获取任务类型文本
    getTaskTypeText(type) {
      return  type;
    },
    
    // 截断文本
    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    
    // 当前页变化
    currentChange(currentPage) {
      this.page.current = currentPage;
      this.loadTaskList();
    },
    
    // 页大小变化
    sizeChange(pageSize) {
      this.page.size = pageSize;
      this.loadTaskList();
    },
    
    // 刷新
    refreshChange() {
      this.loadTaskList();
    },
    
    // 加载任务列表
    loadTaskList() {
      // 无有效chatId时不请求，直接清空
      if (!this.sessionInfo || !this.sessionInfo.chatId) {
        this.data = [];
        this.page.total = 0;
        this.loading = false;
        return;
      }
      
      this.loading = true;
      const requestData = {
        current: this.page.current,
        size: this.page.size,
        chatId: this.sessionInfo.chatId
      };
      
      getAiSessionTaskList(requestData).then(res => {
        if (res.data.code === 200 || res.data.code === 0) {
          const data = res.data.data;
          this.page.total = data.total;
          this.data = data.records || [];
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error(res.data.msg || "获取任务列表失败");
        }
      }).catch(error => {
        this.loading = false;
        console.error("获取任务列表失败:", error);
        this.$message.error("获取任务列表失败，请重试");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-header {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  
  .info-item {
    margin-bottom: 8px;
    
    label {
      font-weight: 500;
      color: #606266;
      margin-right: 8px;
    }
    
    span {
      color: #303133;
    }
  }
}

.task-content,
.task-result {
  line-height: 1.5;
  word-break: break-word;
}

/* 表格单元格文本溢出处理 */
.el-table .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* 确保tooltip正常显示 */
.el-tooltip__popper {
  max-width: 400px;
  word-break: break-all;
  line-height: 1.5;
}

/* 状态标签样式 */
.el-tag {
  margin: 0;
}
</style>
